import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function DigConnectForm({ onSubmit, guideMode }) {
  const [showSecret, setShowSecret] = useState(false);
  const digRegions = ["EU", "US"];
  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);
  const formInitialValues = {
    api_token: "",
    company_id: "",
    region: "",
  };
  const formCheckoutSchema = yup.object().shape({
    api_token: yup.string().required("required"),
    company_id: yup.string().required("required"),
    region: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                type={showSecret ? "text" : "password"}
                name="api_token"
                autoComplete="off"
                label="API Key"
                value={values.api_token}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.api_token && !!errors.api_token}
                helperText={touched.api_token && errors.api_token}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle secret visibility"
                        onClick={handleClickShowSecret}
                        onMouseDown={handleMouseDownSecret}
                      >
                        {showSecret ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="company_id"
                label="Company ID"
                value={values.company_id}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.company_id && !!errors.company_id}
                helperText={touched.company_id && errors.company_id}
                autoComplete="off"
                disabled={guideMode}
              />
              <Box>
                <FormControl
                  sx={{ mt: 2, minWidth: "200px" }}
                  error={touched.region && Boolean(errors.region)}
                >
                  <InputLabel id="dig-region-select-label">
                    Dig Region
                  </InputLabel>
                  <Select
                    labelId="dig-region-select-label"
                    id="dig-region-select"
                    name="region"
                    value={values.region}
                    onChange={handleChange}
                    label="Dig Region"
                    disabled={guideMode}
                  >
                    {digRegions.map((region) => (
                      <MenuItem value={region}>{region}</MenuItem>
                    ))}
                  </Select>
                  {touched.region && errors.region && (
                    <FormHelperText>{errors.region}</FormHelperText>
                  )}
                </FormControl>
              </Box>
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
